import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../Components/ui/PageShell';
import { getUserType } from '../utils/authStorage';

function CandidatesHub() {
  const userType = getUserType();
  const listPath = userType === 'Admin' ? '/Requirments' : '/home';
  const listTitle = userType === 'Admin'
    ? 'View in Requirement List'
    : 'View in My Workbench';

  return (
    <PageShell
      title="Source Profiles"
      subtitle="Source profiles are managed inside your requirement workspace — open it to upload, update status, and track pipeline."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Source Profiles' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-dashboard-grid">
        <Link to={listPath} className="hr-dashboard-card">
          <h3>{listTitle}</h3>
          <p>View all submitted source profiles and manage hiring stages</p>
        </Link>
        <Link to="/work/interviews" className="hr-dashboard-card">
          <h3>Interview Schedule</h3>
          <p>View upcoming interviews and scheduled times</p>
        </Link>
      </div>
    </PageShell>
  );
}

export default CandidatesHub;
